module.exports = __webpack_public_path__ + "static/media/spa-rocks.0d8b6638.svg";